import React from 'react';
import { cn } from '../lib/cn';

/**
 * Input — Campo de texto con soporte opcional de prefix/suffix.
 *
 * Resuelve la deuda técnica del v1: cuando hay icono, usa wrapper
 * flexbox en lugar de position:absolute. Inmune a CSS globales.
 *
 * Uso:
 *   <Input placeholder="Nombre" />
 *
 *   <Input
 *     prefix={<Search className="size-4" />}
 *     suffix={<X className="size-4 cursor-pointer" />}
 *     placeholder="Buscar..."
 *   />
 */
export const Input = React.forwardRef(({
    prefix,
    suffix,
    className,
    type = 'text',
    ...props
}, ref) => {
    const hasAffixes = prefix || suffix;

    if (!hasAffixes) {
        return (
            <input
                ref={ref}
                type={type}
                className={cn(
                    'flex h-9 w-full rounded-lg border border-[hsl(var(--input))] bg-white',
                    'px-3 py-1 text-sm text-slate-900 placeholder:text-slate-400',
                    'transition-colors outline-none',
                    'focus-visible:border-[hsl(var(--brand-light))] focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))]',
                    'disabled:opacity-50 disabled:cursor-not-allowed',
                    className
                )}
                {...props}
            />
        );
    }

    return (
        <div className={cn(
            'flex items-center gap-2 h-9 w-full px-3',
            'rounded-lg border border-[hsl(var(--input))] bg-white',
            'transition-colors',
            'focus-within:border-[hsl(var(--brand-light))] focus-within:ring-2 focus-within:ring-[hsl(var(--ring))]',
            className
        )}>
            {prefix && (
                <span className="flex items-center justify-center text-slate-400 shrink-0">
                    {prefix}
                </span>
            )}
            <input
                ref={ref}
                type={type}
                className="flex-1 min-w-0 bg-transparent border-0 outline-none text-sm text-slate-900 placeholder:text-slate-400 p-0"
                {...props}
            />
            {suffix && (
                <span className="flex items-center justify-center text-slate-400 shrink-0">
                    {suffix}
                </span>
            )}
        </div>
    );
});

Input.displayName = 'Input';
